import getFullName from './getFullName'
import { Colleague } from 'store/user/types'

const getSearchString = (user: Colleague) => `${getFullName(user)} ${user.email}`

export default getSearchString
